import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { PageFooterComponent } from './page-footer/page-footer.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { NavigationService } from './services/navigation/navigation.service';
import { ParametersService } from './services/parameters/parameters.service';
import { ClickOutsideDirective } from './clickOutside/clickOutside.directive';
import { SubscriptionComponent } from './subscription/subscription.component';
import { IsNotIncludedPipe } from './pipe/is-not-included/is-not-included.pipe';

let declarations: any = [PageHeaderComponent, PageFooterComponent, ClickOutsideDirective, SubscriptionComponent, IsNotIncludedPipe];

@NgModule({
  declarations: [...declarations],
  exports: [...declarations],
  imports: [CommonModule, MatIconModule, TranslocoModule],
  providers: [NavigationService, ParametersService],
})
export class SharedModule {}
